module.exports = __webpack_public_path__ + "f99c87407f048beea2d39734af5efcb6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/VC.svg
// module id = tuVf
// module chunks = 0